import React from "react";
import { Link } from "react-router-dom";
import HeadMeta from "@/components/sections/HeadMeta";
import Header from "@/components/sections/Header";
import Footer from "@/components/sections/Footer";
import Subvencio from "@/components/sections/Subvencio";
import { usePageInitialization } from "@/hooks/usePageInitialization";

const PoliticaPrivacidadPage = () => {
  usePageInitialization("Política de privacidad - Elemental Value", { handleSplash: false, initSwiper: false });
  
  return (
    <>
      <HeadMeta
        title="Política de privacidad | Elemental Value"
        description="Cómo Elemental Value (EV23 FINANCE, S.L.) trata tus datos personales conforme al RGPD y la LOPDGDD: finalidades, base legal, derechos y conservación."
        canonicalPath="/politica-privacidad"
      />
      <Header />
      <main className="legal-page">
        <div className="legal-content">
          <h1>Política de privacidad</h1>
...
          <section>
            <h2>8. Modificaciones</h2>
            <p>
              Elemental Value se reserva el derecho a modificar la presente Política de privacidad para adaptarla a novedades legislativas o jurisprudenciales. En dichos supuestos, anunciará en esta página los cambios introducidos con razonable antelación a su puesta en práctica.
            </p>
          </section>

        </div>
      </main>
      <Footer />
      <Subvencio />
    </>
  );
};

export default PoliticaPrivacidadPage;
